__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-18-1787051621-stable-dev/";